export const emailTemplates = [
  {
    id: 'welcome',
    name: 'Welcome Email',
    subject: 'Welcome to Our Service!',
    body: `
      <h2 style="color: #4f46e5; font-size: 24px; margin-bottom: 16px;">Welcome aboard!</h2>
      <p style="margin-bottom: 16px;">Thank you for joining us. We're excited to have you as a customer.</p>
      <p style="margin-bottom: 16px;">Here are some resources to help you get started:</p>
      <ul style="margin-bottom: 16px;">
        <li>Getting Started Guide</li>
        <li>Frequently Asked Questions</li>
        <li>Video Tutorials</li>
      </ul>
      <div style="background-color: #f3f4f6; padding: 16px; border-radius: 8px; margin-top: 24px;">
        <p style="margin: 0;">If you have any questions, please contact our support team.</p>
      </div>
    `
  },
  {
    id: 'newsletter',
    name: 'Monthly Newsletter',
    subject: 'Your Monthly Newsletter',
    body: `
      <div style="text-align: center; margin-bottom: 24px;">
        <h1 style="color: #4f46e5; font-size: 28px;">Monthly Newsletter</h1>
        <p style="color: #6b7280;">Stay updated with our latest news and updates</p>
      </div>
      
      <div style="margin-bottom: 24px;">
        <h2 style="color: #1f2937; font-size: 20px; border-bottom: 1px solid #e5e7eb; padding-bottom: 8px;">This Month's Highlights</h2>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin ac metus justo.</p>
      </div>
      
      <div style="margin-bottom: 24px;">
        <h2 style="color: #1f2937; font-size: 20px; border-bottom: 1px solid #e5e7eb; padding-bottom: 8px;">Upcoming Events</h2>
        <ul>
          <li>Event 1 - January 15th</li>
          <li>Event 2 - January 22nd</li>
          <li>Event 3 - February 5th</li>
        </ul>
      </div>
      
      <div style="background-color: #f3f4f6; padding: 16px; border-radius: 8px; margin-top: 24px; text-align: center;">
        <p style="margin: 0;">Thank you for subscribing to our newsletter!</p>
      </div>
    `
  },
  {
    id: 'promotion',
    name: 'Special Offer',
    subject: 'Special Offer Just for You!',
    body: `
      <div style="text-align: center; background-color: #fee2e2; padding: 24px; border-radius: 8px; margin-bottom: 24px;">
        <h1 style="color: #dc2626; font-size: 32px; margin: 0;">SPECIAL OFFER</h1>
        <p style="font-size: 20px; margin-top: 8px;">Limited Time Only!</p>
      </div>
      
      <div style="text-align: center; margin-bottom: 24px;">
        <h2 style="color: #1f2937; font-size: 24px;">Get 25% Off Your Next Purchase</h2>
        <p>Use code: <strong>SAVE25</strong> at checkout</p>
      </div>
      
      <div style="text-align: center; margin-bottom: 24px;">
        <a href="#" style="display: inline-block; background-color: #dc2626; color: white; padding: 12px 24px; text-decoration: none; border-radius: 4px; font-weight: bold;">SHOP NOW</a>
      </div>
      
      <div style="font-size: 12px; color: #6b7280; text-align: center; margin-top: 24px;">
        <p>Offer valid until January 31st. Terms and conditions apply.</p>
      </div>
    `
  }
];

export const getTemplateById = (id) => {
  return emailTemplates.find(template => template.id === id);
};

export const getAllTemplates = () => {
  return emailTemplates;
};
